<template lang="pug">
.v-features-card.features-card(
		v-if="data"
		:style="{backgroundColor: data.background || '#0E0E0F'}"
		:class="data.className")
	.features-card__wrap
		.features-card__header
			img.features-card__image(
				v-if="data.image"
				:src="data.image?.src"
				:alt="data.image?.alt")
			.features-card__subtitle(v-if="data.subtitle" :style="{ color: data.color || '#0E0E0F'}") {{ data.subtitle }}
		h4.features-card__title(v-if="data.title" :style="{ color: data.color || '#0E0E0F'}") {{ data.title }}
	.features-card__wrap
		.features-card__separator(:style="{ backgroundColor: data.color || '#0E0E0F'}")
		.features-card__text(v-if="data.text" v-html="data.text" :style="{ color: data.color || '#0E0E0F'}")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>